import { render, staticRenderFns } from "./UpsellSlider.vue?vue&type=template&id=531c0ef8&scoped=true&"
import script from "./UpsellSlider.vue?vue&type=script&lang=js&"
export * from "./UpsellSlider.vue?vue&type=script&lang=js&"
import style0 from "./UpsellSlider.vue?vue&type=style&index=0&id=531c0ef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531c0ef8",
  null
  
)

export default component.exports